<section>
    Yo I'm David O! The TL;DR of it all is I'm a Front-End/Software/React engineer by day <a href="https://mailgun.com">@Mailgun</a>
    and a plethora of other things by night. During the day and night I'm a husband to a beautiful wife and a father to 2 knuckleheads, <br />
    a future pro futboler(this is a real term right?) and a future karate black belt. <a href="mailto:david@davidnortiz.com">Say whats up</a>!
</section>

<style>
    section {
        text-align: left;
    }
</style>